import type { CampaignName } from 'src/common/enums/campaigns';
import {
  INFLUENCER_ADDITIONAL_CONFIGS,
  INFLUENCER_SUBSCRIPTION_ADDITIONAL_CONFIGS,
  type InfluencerCampaigns,
  type InfluencerSubscriptionCampaigns,
  isInfluencerCampaignKey,
  isInfluencerSubscriptionCampaignKey,
} from '../influencers.config';

type InfluencerAdditionalConfigs = (typeof INFLUENCER_ADDITIONAL_CONFIGS)[InfluencerCampaigns];
type InfluencerSubscriptionAdditionalConfigs =
  (typeof INFLUENCER_SUBSCRIPTION_ADDITIONAL_CONFIGS)[InfluencerSubscriptionCampaigns];

export const useInfluencerAdditionalConfigs = (
  influencerCampaign?: CampaignName,
): InfluencerAdditionalConfigs | null => {
  if (influencerCampaign && isInfluencerCampaignKey(influencerCampaign)) {
    return INFLUENCER_ADDITIONAL_CONFIGS[influencerCampaign] ?? null;
  }

  return null;
};

export const useInfluencerSubscriptionAdditionalConfigs = (
  influencerSubscriptionCampaign: string | undefined,
): InfluencerSubscriptionAdditionalConfigs | null => {
  if (influencerSubscriptionCampaign && isInfluencerSubscriptionCampaignKey(influencerSubscriptionCampaign)) {
    return INFLUENCER_SUBSCRIPTION_ADDITIONAL_CONFIGS[influencerSubscriptionCampaign] ?? null;
  }

  return null;
};
